export default __webpack_public_path__ + "static/media/physical-object.66305cbd.svg";